import { useState } from 'react'
import BugReportModal from './BugReportModal'
import { useAuth } from '../context/AuthContext'

export default function BugReportLink({ className = '', style, label = '🐞 Report a bug' }) {
  const { user } = useAuth()
  const [open, setOpen] = useState(false)
  if (!user) return null
  // When the consumer passes a className, let it own the styling.
  // When it doesn't, fall back to a minimal underlined-button look.
  const baseStyle = className
    ? { background: 'none', border: 'none', cursor: 'pointer', font: 'inherit' }
    : { background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: 'inherit', font: 'inherit', textDecoration: 'underline' }
  return (
    <>
      <button
        className={className}
        style={{ ...baseStyle, ...style }}
        onClick={() => setOpen(true)}
      >
        {label}
      </button>
      {open && <BugReportModal onClose={() => setOpen(false)} />}
    </>
  )
}
